(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('InvitationListController', InvitationListController);

    InvitationListController.$inject = ['$state', 'Invitation', 'AlertService', 'pagingParams', 'paginationConstants' ];

    function InvitationListController ($state, Invitation, AlertService, pagingParams, paginationConstants) {

        var vm = this;

        vm.invitations = [];
        vm.predicates = pagingParams.predicates;
        vm.charToSearch = pagingParams.search;

        vm.page = 1;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.currentState = "invitation-list";
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;


        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

         function loadAll  (){
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                search: vm.charToSearch,
                sort: sort()
            }
            Invitation.invitationList(body, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.invitations = data;
            }

        }

        vm.sendMail = function (invite){
            Invitation.sendMail(invite,function(){
            AlertService.success("Mail send successfully");
            }, onError)
        }

        vm.deleteInvitation = function (id){
            Invitation.delete({id: id},function(){
                vm.loadAll();
                AlertService.success("Delete mail successfully");
            }, onError)
        }


        function onError(){
            AlertService.error("Something wrong");
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});

        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.loadAll();
            transition();

        }

        vm.loadAll();

    }
})();
